import { Flex, Typography, Divider } from "antd";
import { dateFormat } from "utils";
import { useStores } from "stores";
import { ReturnButton } from "ui/Buttons/ReturnButton";
import { routes } from "constants/routes";
import { useNavigate } from "react-router-dom";
import { DIRECTION_TEXT } from "interfaces";

export const ContractHeader = () => {
  const { contractCard } = useStores();
  const { unk, created, direction } = contractCard.card;
  const navigate = useNavigate();

  return (
    <Flex vertical>
      <Flex gap="12px" align="baseline">
        <ReturnButton onClick={() => navigate(`/${routes.contracts}`)} disabled={false} loading={false} />
        <Typography.Title level={1}>Договор</Typography.Title>
        <Typography.Text>
          УНК {unk} от {dateFormat(created)} на {DIRECTION_TEXT[direction]}
        </Typography.Text>
      </Flex>

      <Divider className="margin-top-none margin-bottom-none" />
    </Flex>
  );
};
